import { useQuery } from "@tanstack/react-query";
import subOrdersService from "services/admin/sub-orders.service";

export const useGetSubOrders = (orgID, queryParams = {}) => {
    console.log('queryParams', queryParams)
    return useQuery({
        queryKey: ['getSubOrders', orgID, queryParams],
        queryFn: async () => {
            return subOrdersService.getAllByOrgID(orgID, queryParams)
        },
        select: (data) => data.data,
        refetchOnWindowFocus: false,
    })
}